export const PRODUCT_ANALYSIS_RUN_STAGES = [
  { id: "catalog", label: "Подготовка товара" },
  { id: "finance", label: "Финансовые операции" },
  { id: "sales", label: "Продажи и возвраты" },
  { id: "availability", label: "Наличие FBO" },
  { id: "promotion", label: "Продвижение" },
  { id: "economics", label: "Экономика" },
  { id: "trend", label: "Тренд и стабильность" },
  { id: "rating", label: "Рейтинг" },
  { id: "signals", label: "Сигналы" },
  { id: "llm", label: "Резюме (LLM)" },
] as const;

export type ProductAnalysisRunStageId = (typeof PRODUCT_ANALYSIS_RUN_STAGES)[number]["id"];

export interface ProductAnalysisRunProgress {
  completedStages: ProductAnalysisRunStageId[];
  currentStages: ProductAnalysisRunStageId[];
}

export interface ProductAnalysisRunState {
  kind: "run";
  runId: string;
  status: "created" | "running" | "failed";
  offerId: string;
  productName?: string;
  periodFrom: string;
  periodTo: string;
  progress: ProductAnalysisRunProgress;
  error?: string;
}
